<!-- dialog view -->
<h2 mat-dialog-title>{{ dataModule.name }}</h2>
<mat-dialog-content class="mat-typography">
  <p>
    @if (dataModule.content_type === 'application/pdf') {
      <iframe [src]="pdfData" style="width: 100%;height: 100vh;border: 0px solid #000;"></iframe>
    }
    @if (dataModule.content_type !== 'application/pdf') {
      <img [src]="dataModule.decrypted_file" alt="{{dataModule.name}}" style="width: 100%"/>
    }
  </p>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button mat-flat-button class="bg-error text-white" mat-dialog-close>Close</button>
</mat-dialog-actions>
